module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/de-card-drag.ce61112208a2ff3a7c52.gif";